<script>
  import { onMount, createEventDispatcher } from "svelte";
  const dispatch = new createEventDispatcher();
  import Field from "../FormField.svelte";
  import TextBox from "../HTMLElements/Textbox.svelte";
  import Select from "../HTMLElements/Select.svelte";
  import wrappedFetch from "../../wrappedFetch.js";
  export let selectedSchoolIds=[];
  export let childID;
  export let selected;
  let isDirty=false;

  //let keywords = [];
  let keyword = { value: "", isValid: true, isDirty: false };
  let schoolList;
  let noResultFound = false;
  let error = false;
  let ref = null;
  const listSchools = async()=>{
    noResultFound = false;
    keyword.isDirty = true;
    if(keyword.value == "")    
    keyword.isValid = false;
    else 
    {
      const resp = await wrappedFetch(
        `/child/GetAvailableSchoolsByKeyword?childId=${childID}`,
        {
          method: "post",
          body: JSON.stringify(keyword.value.split(" ")),
          headers: {
            "Content-Type": "application/json"
          }
        }
      );

      schoolList = await resp.json();

      schoolList.forEach((s, key) => {
        schoolList[key]["label"] =  s.name + ' ('+s.postcode+')';
      });
      if(selectedSchoolIds.length > 0)
        schoolList= schoolList.filter(s => { if(!selectedSchoolIds.includes(s.id)) return s;}); 

      if(schoolList.length == 0)
        noResultFound = true;
      else
        noResultFound = false;
    }

    _paq.push(['trackSiteSearch',
      keyword.value,
      "Keyword",
      schoolList.length
    ]);
  }

  onMount(() => {
    if(ref) ref.focus();
  })
  const onKeyUp = (e) => {
    if ((e.detail.which || e.detail.keyCode) == 13) {     
    listSchools();
    }
  };

  const onAddSchoolFromSelect = () => {
    isDirty = true;
    error =false;
    if(selected)
      dispatch('addSchool',selected.id);
      else
     error = true
  };
  // const onAddSchool = (e) => {
  //   error =false;
  //   if(e.target.value)
  //     dispatch('addSchool', e.target.value);
  //     else
  //    error = true
  // };
 
</script>

<Field label="Keyword Search">
  <span slot="inputField">
    <TextBox
      placeholder="Keywords"
      isRequired="true"
      bind:text={keyword.value}
      bind:isValid={keyword.isValid}
      bind:isDirty={keyword.isDirty}
      bind:ref
      label="keyword for search"
      on:keyup={onKeyUp} />
      <button class="button is-purple" on:click={listSchools}>Search</button>
  </span>
  
</Field>





{#if schoolList && schoolList.length > 0}

<Select items={schoolList} bind:selected isRequired={true} isDirty={isDirty}  placeholder="--- Please select a school ---"
        label="a school"  selectedValueText="id" on:change={onAddSchoolFromSelect}/>
    {#if error}
      
      <div class="notification is-invalid">
        <p class="help" style="margin-bottom:0px">Please select a school</p>
      </div>
    {/if}
  <!-- <div class="field">
    <button class="button is-primary" on:click={onAddSchool}>Add School</button>
  </div> -->
{/if}
{#if noResultFound}
  <p style="margin-bottom:0px;"> No result found for the search term. </p>
{/if}
